import { Input, TextInput } from "@mantine/core";

export default function TemplateNameSection(props: {
  templateForm: {
    name: { value: string; error: string };
    description: { value: string; error: string };
  };
  setTemplateForm: (templateForm: {
    name: { value: string; error: string };
    description: { value: string; error: string };
  }) => void;
}) {
  const { templateForm, setTemplateForm } = props;

  const onChangeTemplateName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTemplateForm({
      ...templateForm,
      name: {
        value: e.target.value,
        error: "",
      },
    });
  };
  const onChangeTemplateDescription = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTemplateForm({
      ...templateForm,
      description: {
        value: e.target.value,
        error: "",
      },
    });
  };

  return (
    <>
      <Input.Wrapper label="템플릿명" error={templateForm.name.error}>
        <TextInput
          value={templateForm.name.value}
          onChange={onChangeTemplateName}
          placeholder="템플릿명을 입력해주세요."
        />
      </Input.Wrapper>
      <Input.Wrapper label="상세설명" error={templateForm.description.error}>
        <TextInput
          value={templateForm.description.value}
          onChange={onChangeTemplateDescription}
          placeholder="상세설명을 입력해주세요."
        />
      </Input.Wrapper>
    </>
  );
}
